import { DedicatedPackageOutput } from '@allocab/allocab-dedicated-driver-types';
import { useState } from 'react';

import { useAssignTriPackageToDriver } from '../../hooks/useAssignTriPackageToDriver';
import { ToastManager } from '../../services/toast/utils';
import { t } from '../../services/translation/translation';
import { getFullName } from '../../utils/common';
import { PrimaryButton } from '../button/PrimaryButton';
import { ConfirmationModal } from '../modal/ConfirmationModal';

type Props = {
  tripPackage: DedicatedPackageOutput;
  driverKey: string;
};

export const TripPackageAssignButton = ({ tripPackage, driverKey }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mutate: assignTripPackage, isLoading } = useAssignTriPackageToDriver(tripPackage.id);

  const handleAssign = () => {
    assignTripPackage(
      { driverKey: driverKey },
      {
        onSuccess: () => {
          setIsOpen(false);
          ToastManager.show({
            severity: 'success',
            message: t('trip-package.assign-modal.success', {
              driverName: getFullName(tripPackage.driver?.firstName, tripPackage.driver?.lastName),
            }),
          });
        },
      },
    );
  };

  return (
    <>
      <PrimaryButton onClick={() => setIsOpen(true)}>{t('common.accept')}</PrimaryButton>
      {isOpen ? (
        <ConfirmationModal
          isLoading={isLoading}
          title={t('trip-package.accept-title')}
          onClose={() => setIsOpen(false)}
          onConfirm={handleAssign}
          confirmLabel={t('trip-package.accept-title')}
          type="gradient"
        >
          <p className="mb-0">
            {t('trip-package.accept-text', {
              driverName: getFullName(tripPackage.driver?.firstName, tripPackage.driver?.lastName),
            })}
          </p>
        </ConfirmationModal>
      ) : null}
    </>
  );
};
